var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.39 51.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 18.53,
    cy: 24.98,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.93,30.78c.6,4-.5,7-3.4,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.23,12.78c3.5,3.8,5.5,9.1,4.3,14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.63,21.68c4-.3,6.1-.9,9.4-2.9,3-1.8,7.4-3.7,11.8-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.23,35.38c-4.7-1.2-9.4-2.7-12.9-4.8-3.3-2-5.7-2.6-9.7-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M168.53,24.88l-10-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.13,17.38c.1,4.7,0,9.2-.2,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.13,17.38c-6-.2-12.2-.8-17.4-1.7-26.5-4.9-53.9-10.4-86.4-6.9-15.2,1.6-31.4,4.7-45.2,11.3-4.4,2.1-8.8,4.6-6.5,7.4,2.8,3.4,7,5.4,10.8,7.1,3,1.4,6.1,2.6,9.2,3.7,15.5,5.3,31.9,6.6,48.1,7.2,15.8,.6,31.9-.8,47.1-5.4,5.6-1.7,11.1-3.9,16.7-5.9,3.9-1.4,8-2.6,12.2-2.7,3.9-.1,7,.1,11.4,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.03,31.58c9.3,.3,19.7,9.5,25.9,12.7,1.6,.9,3.2,1.5,5.4,2,1.1,.2-15-18.8-14.4-22.1,.6-3.4,2.7-7.2,5.1-10.6,4.4-6.2,9.7-11.3,9-11.5-1.7-.4-3.7,.8-5.1,1.9-4.8,3.6-7.7,6.1-12.4,9-3.6,2.2-9.3,3.7-13.3,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M72.93,7.58c2.1-.7,4.3-1.3,6.4-1.9,4.9-1.3,9.9-2.2,15.1-2,2.5,.1,5.3,.2,7.7,1,0,0-5,2.3-4.8,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M101.83,43.58c2.2,.2,4.5,.4,6.8,.5,5.1,.2,8.2,.5,13.8-.7,2.5-.5,5.1-1.4,7.3-2.7,0,0-5.1-.7-4.5-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M61.83,44.88c2.1,.7,5.6,2.2,7.8,2.7,4.9,1.3,7.4,1.9,13.1,2.1,2.5,.1,7-.2,9.4-1.1,0,0-6.8-1.1-5.3-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.23,31.98s10.6-.3,15.7,.2,6.3,1.5,6.3,1.5h0c-1.4,1.3-1.6,1.6-2.3,2.1-1.4,1-3,1.8-4.7,2.2l-2.9,.8s-6.2-1.3-10.1-2.1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDace);
export default __webpack_public_path__ + "static/media/Dace.35e6f5ffebc34d91dc20a4fd30d2b9af.svg";
export { ForwardRef as ReactComponent };